export class ClassType {
    id: string;
    name: string;
    semesterId: number
}

export const CLASS_TYPE: ClassType[] = [
    {
        id: 'summer_school',
        name: 'Summer School',
        semesterId: 2,
    },
    {
        id: 'winter_school',
        name: 'Winter School',
        semesterId: 1,
    },
];




// WEBPACK FOOTER //
// ./src/holiday/models/ClassType.ts